module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', {
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.status === 0 ? "OK" : _vm.status.toLocaleString()))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-21943872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/status-value.vue
// module id = 566
// module chunks = 0